module.exports = __webpack_public_path__ + "img/img-messagerie_eole.23c12da7.png";